export const TRADESHOW_FETCHED_ALL = 'tradeshow.FETCH_ALL';
export const TRADESHOW_FETCHED_HIRED = 'tradeshow.FETCH_HIRED';
export const TRADESHOW_HIRE = 'tradeshow.HIRE';
export const TRADESHOW_STARTED = 'tradeshow.STARTED';
export const TRADESHOW_ENDED = 'tradeshow.ENDED';
